import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input', 'dropdown', 'frame', 'option', 'pickedRow', 'chips', 'chip', 'chipLabel', 'chipTemplate', 'picked']
  static values = { url: String }

  connect() {
    this.boundClickOutside = this.clickOutside.bind(this)
    document.addEventListener('mousedown', this.boundClickOutside)
  }

  disconnect() {
    document.removeEventListener('mousedown', this.boundClickOutside)
  }

  open() {
    this.dropdownTarget.classList.remove('hidden')
    this.search()
  }

  close() {
    this.dropdownTarget.classList.add('hidden')
  }

  clickOutside(event) {
    if (!this.element.contains(event.target)) this.close()
  }

  search() {
    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set('query', this.inputTarget.value.trim())
    this.pickedTargets.forEach((picked) => url.searchParams.append('except[]', picked.value))
    this.frameTarget.src = url.toString()
  }

  pick(event) {
    event.preventDefault()
    this.addChip(event.currentTarget)
  }

  remove(event) {
    event.preventDefault()
    event.currentTarget.closest('[data-member-picker-target="chip"]').remove()
    this.pickedChanged()
  }

  removeAll(event) {
    event.preventDefault()
    this.chipTargets.forEach((chip) => chip.remove())
    this.pickedChanged()
  }

  pickedChanged() {
    this.pickedRowTarget.classList.toggle('hidden', !this.hasChipTarget)
    if (!this.dropdownTarget.classList.contains('hidden')) this.search()
  }

  keydown(event) {
    if (event.key === 'Escape') {
      this.close()
      this.inputTarget.blur()
    }
    if (event.key === 'Enter') {
      event.preventDefault()
      if (this.hasOptionTarget) this.addChip(this.optionTarget)
    }
  }

  addChip(option) {
    const chip = this.chipTemplateTarget.content.firstElementChild.cloneNode(true)
    chip.querySelector('[data-member-picker-target="picked"]').value = option.dataset.value
    chip.querySelector('[data-member-picker-target="chipLabel"]').textContent = option.dataset.label
    this.chipsTarget.appendChild(chip)
    this.inputTarget.value = ''
    this.pickedChanged()
  }
}
